import england_flag from "../assets/languages/england_flag.png";
import france_flag from "../assets/languages/france_flag.png";

export const languages = [
    { index: 'fr', name: {fr:'Français', en: 'French'}, image: france_flag},
    { index: 'en', name: {fr:'Anglais', en: 'English'}, image: england_flag}
]